import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { StaticImage } from 'gatsby-plugin-image';
import Countdown from 'react-countdown';

import Logo from 'components/misc/Logo';
import ArenaInfoMen from 'components/utils/ArenaInfoMen';
import * as style from 'styles/components/utils/takeOver2024.module.scss';

import i01 from '../../images/takeover/timeline-01.svg';
import i02 from '../../images/takeover/timeline-02.svg';
// import i03 from '../../images/takeover/timeline-03.svg';
import i04 from '../../images/takeover/timeline-04.svg';
import i05 from '../../images/takeover/timeline-05.svg';
import i06 from '../../images/takeover/timeline-06.svg';
import i07 from '../../images/takeover/timeline-07.svg';
import i08 from '../../images/takeover/2025/process.svg';

const TakeOver = ({ takeoverConfig }) => {

    const countdownDate = takeoverConfig.countdownDate ? new Date(takeoverConfig.countdownDate) : null;
    const soldWomen = takeoverConfig.soldCardsWomen ? takeoverConfig.soldCardsWomen : null;
    const soldMen = takeoverConfig.soldCardsMen ? takeoverConfig.soldCardsMen : null;
    const youtubeVideoId = takeoverConfig.youtubeVideoId ? takeoverConfig.youtubeVideoId : null;

    const [isTakeOverActive, toggleTakeOver] = useState(true);

    function fakeNavigation() {
        toggleTakeOver(false);
        document.getElementById("seasonalTakeover").remove();
    }

    const buildTimeline = () => {

        const currentDate = new Date();

        // All the phases in the timeline
        const p02Start = new Date('2023-11-23T00:00:00');
        const p02End = new Date('2023-12-12T23:59:59');

        // const p03Start = new Date('2023-02-01:00:00');
        // const p03End = new Date('2023-02-01T23:59:59');

        const p04Start = new Date('2023-12-13T00:00:00');
        const p04End = new Date('2023-12-14T23:59:59');

        const p05Start = new Date('2023-12-15T00:00:00');
        const p05End = new Date('2023-12-17T23:59:59');

        const p06Start = new Date('2023-12-18T00:00:00');
        const p06End = new Date('2023-12-19T23:59:59');

        const p07Start = new Date('2023-12-20T00:00:00');
        const p07End = new Date('2024-01-08T23:59:59');

        // const p08Start = new Date('2024-01-09T00:00:00');
        let timelineImage = i01;
        if( currentDate < p02Start) {
            timelineImage = i01;
        } else if (currentDate >= p02Start && currentDate <= p02End) {
            timelineImage = i02;
        } else if (currentDate >= p04Start && currentDate <= p04End) {
            timelineImage = i04;
        } else if (currentDate >= p05Start && currentDate <= p05End) {
            timelineImage = i05;
        } else if (currentDate >= p06Start && currentDate <= p06End) {
            timelineImage = i06;
        } else if (currentDate >= p07Start && currentDate <= p07End) {
            timelineImage = i07;
        } else if(currentDate > p07End) {
            timelineImage = i08;
        }
        return (
            <div className={style.takeOver__timeLine}>
                <img src={timelineImage} alt="Säsongskort - Tidslinje för händelser" />
            </div>
        )
    };

    const renderer = ({ completed, formatted }) => {
        if (completed) {
            return (
                <span className={style.takeOver__counter}>
                    .
                </span>
            );
        }
        return (
            <div className={style.takeOver__counter}>
                <div className={style.takeOver__counterHeader}>
                    <div className={style.takeOver__counterTitle}>
                        Dagar
                    </div>
                    <div className={style.takeOver__counterTitle}>
                        Timmar
                    </div>
                    <div className={style.takeOver__counterTitle}>
                        Minuter
                    </div>
                    <div className={style.takeOver__counterTitle}>
                        Sekunder
                    </div>
                </div>
                <div className={style.takeOver__counterBody}>
                    <div className={style.takeOver__counterNumber}>
                        {formatted.days}
                    </div>
                    <div className={style.takeOver__counterDivider}>
                        <div className={style.takeOver__counterDividerDot} />
                        <div className={style.takeOver__counterDividerDot} />
                    </div>
                    <div className={style.takeOver__counterNumber}>
                        {formatted.hours}
                    </div>
                    <div className={style.takeOver__counterDivider}>
                        <div className={style.takeOver__counterDividerDot} />
                        <div className={style.takeOver__counterDividerDot} />

                    </div>
                    <div className={style.takeOver__counterNumber}>
                        {formatted.minutes}
                    </div>
                    <div className={style.takeOver__counterDivider}>
                        <div className={style.takeOver__counterDividerDot} />
                        <div className={style.takeOver__counterDividerDot} />
                    </div>
                    <div className={style.takeOver__counterNumber}>
                        {formatted.seconds}
                    </div>
                </div>
                <div className={style.takeOver__counterFooter}>
                    Tills säsongskorten släpps
                </div>
            </div>
        );
    };

    return (
        <div id="seasonalTakeover" className={style.takeOver__wrapper}>
            {isTakeOverActive &&
            <Helmet>
                <body data-modal-open="true" />
            </Helmet>
            }
            <div className={style.takeOver__logo}>
                <Logo black />
            </div>

            <div className={style.takeOver__closeWrapper}>
                <button type="button" onClick={() => fakeNavigation(false)}>Hammarbyfotboll.se</button>
            </div>

            <div className={style.takeOver__content}>

                <div className={style.takeOver__counterWrapper}>
                    <Countdown date={countdownDate} renderer={renderer} zeroPadTime={2} />
                </div>
                <div className={style.takeOver__header}>
                    <h1>
                        Köp säsongskort till<br />
                        våra läktare
                    </h1>
                    <p>
                        Det är dags att fylla våra läktare inför en ny säsong.<br />
                        Från och med den 13/11 kan du förnya ditt säsongskort.
                    </p>
                </div>
                {youtubeVideoId && (
                    <div className={style.takeOver__video}>
                        <div className={style.takeOver__embedWrapper}>
                            <iframe src={`https://www.youtube.com/embed/${youtubeVideoId}`} title="Hammarby Fotboll" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen />
                        </div>
                    </div>
                )}

                {buildTimeline()}

                <div className={style.takeOver__rowColumns}>
                    <div className={`${style.takeOver__column} ${style.takeOver__columnWide}`}>
                        {soldMen && (
                            <p className={style.takeOver__columnPreamble}>
                                {soldMen} sålda säsongskort till Allsvenskan
                            </p>
                        )}
                        <h2>
                            Säsongskort till herrlaget 2025
                        </h2>
                        <p>
                            Efter ett år med både toppar och dalar i ryggen är det dags att förbereda sig för en ny säsong med siktet inställt på fler och större framgångar. 2023 var året då unga talanger från grönvita led tog både plats och kommando i startelvan och 2024 ska laget stå väl rustat för att ta Hammarby mot toppen. Gruppspelsmatcherna i Svenska Cupen får du på köpet. Vi ses på Nya Söderstadion!
                        </p>
                        <a className={style.takeOver__columnCta} href="https://hammarbyfotboll.se/biljetter#sasongskort" target="_blank" rel="noreferrer">Förnya säsongskortet till Allsvenskan</a>
                    </div>

                    <div className={`${style.takeOver__column} ${style.takeOver__columnNarrow}`}>
                        <div className={`${style.takeOver__seasonCard} ${style.takeOver__seasonCardMen}`}>
                            <StaticImage
                                src="../../images/takeover/2025/sc-herr-2025.png"
                                alt="Hammarby Fotboll - Allsvenskan"
                                loading="lazy"
                            />
                        </div>
                    </div>
                </div>

                <ArenaInfoMen />

                <div className={style.takeOver__rowColumns}>
                    <div className={`${style.takeOver__column} ${style.takeOver__columnWide}`}>
                        {soldWomen && (
                            <p className={style.takeOver__columnPreamble}>
                                {soldWomen} sålda säsongskort
                            </p>
                        )}
                        <h2>
                            Säsongskort till Damlaget 2025
                        </h2>
                        <p>
                            Med dubbla titlar och bäst publik i Sverige kan vi verkligen kika fram emot nästa år med gott mod! Förutom SM-guld, cup-guld och framgångar för våra spelare under VM förra säsongen har vi visat att vi leder utvecklingen inom svensk fotboll på damsidan, både på plan och på läktare. Allt detta sammantaget gör att vi verkligen kan se framåt mot härliga tider, inte minst på Kanalplan!
                        </p>
                        <a className={style.takeOver__columnCta} href="https://hammarbyfotboll.se/biljetter#sasongskort" target="_blank" rel="noreferrer">Förnya säsongskortet till Damallsvenskan</a>
                    </div>
                    <div className={`${style.takeOver__column} ${style.takeOver__columnNarrow}`}>
                        <div className={`${style.takeOver__seasonCard} ${style.takeOver__seasonCardWomen}`}>
                            <StaticImage
                                src="../../images/takeover/2025/sc-dam-2025.png"
                                alt="Hammarby Fotboll - Obos damallsvenskan"
                                loading="lazy"
                            />
                        </div>
                    </div>
                </div>

                <ArenaInfoMen />

                <div className={style.takeOver__textBlock}>
                    <h2>Dela upp dina säsongskort</h2>
                    <p>
                        Om du köper fler säsongskort kommer alla säsongskort att bli kopplade till ett konto med samma namn, något som inte går att ändra efter genomfört köp. Fördelen med att ha ett eget konto är att du själv kan administrera ditt eget säsongskort, skicka vidare matchbiljetter, ta del av nyhetsbrev och förköpskoder samt få ditt eget namn tryckt på kortet.
                    </p>
                    <p>
                        Maila <a href="mailto:biljetter@hammarbyfotboll.se">biljetter@hammarbyfotboll.se</a> så hjälper vi dig!
                    </p>
                </div>

                <div className={style.takeOver__textBlock}>
                    <h2>Säsongskortskön</h2>
                    <p>
                        Om du köper fler säsongskort kommer alla säsongskort att bli kopplade till ett konto med samma namn, något som inte går att ändra efter genomfört köp. Fördelen med att ha ett eget konto är att du själv kan administrera ditt eget säsongskort, skicka vidare matchbiljetter, ta del av nyhetsbrev och förköpskoder samt få ditt eget namn tryckt på kortet.
                    </p>
                    <p>
                        Maila <a href="mailto:biljetter@hammarbyfotboll.se">biljetter@hammarbyfotboll.se</a> så hjälper vi dig!
                    </p>
                </div>

                <div className={style.takeOver__textBlock}>
                    <h2>OBS! Nyförsäljningen börjar 20 februari</h2>
                    <p>
                        Efter förnyelseperioden är det platsbytardagar för de som har förnyat sina kort. Därefter erbjuds de ej förnyade säsongskorten till försäljning för de som står i kön. Efter det drar nyförsäljningsperioden i gång.
                    </p>
                </div>

            </div>

            <div className='style.takeOver__footer'>
                <div className={style.takeOver__service}>
                    <div className={style.takeOver__serviceContainer}>
                        <h3>Öppettider servicecenter</h3>
                        <div className={style.takeOver__serviceRow}>
                            <div className={style.takeOver__serviceColumn}>
                                <h4>Första veckan (xx - xx januari)</h4>
                                <p>
                                    Tisdag - torsdag: 9 - 17<br />
                                    Fredag: 9 - 15
                                </p>
                            </div>
                            <div className={style.takeOver__serviceColumn}>
                                <h4>Resterande veckor</h4>
                                <p>
                                    Måndag - onsdag: x-xx<br />
                                    Torsdag: x-xx<br />
                                    Fredag: endast mail/chatt
                                </p>
                            </div>
                            <div className={style.takeOver__serviceColumn}>
                                <h4>Kontakt</h4>
                                <p>
                                    Telefonnummer: <strong><a href="phone:084628813">08 462 88 13</a></strong><br />
                                    Email: <strong><a href="mailto:biljetter@hammarbyfotboll.se">biljetter@hammarbyfotboll.se</a></strong><br />
                                    Information: <strong><a href="https://www.hammarbyfotboll.se/sasongskort/">hammarbyfotboll.se/sasongskort</a></strong>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
};
export default TakeOver;
